import { IShipmentStopTypes } from 'types/graphqlTypes'
import { TStopSchema } from '../schema/ShipmentSchema/StopSchema'

/**
 * Returns true if there is at least one pickup and one delivery
 * in an array of stops
 */
export const isStopsValid = (stops: TStopSchema[]): boolean => {
  if (stops) {
    const stopTypes = stops.map(({ stopType }) => stopType)
    return (
      stopTypes.includes(IShipmentStopTypes.pickup) &&
      stopTypes.includes(IShipmentStopTypes.delivery)
    )
  }
  return false
}
